/** @jsxImportSource react */ // "use client";

import { MenuIcon, PanelsTopLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PublicMenu } from '@/components/react/menu-public';
import { Sheet, SheetHeader, SheetContent, SheetTrigger, SheetTitle } from '@/components/ui/sheet';
//import { Route } from '@/routes/__root';

export function SheetMenuPublic() {
	//	const { user } = Route.useRouteContext();

	return (
		<Sheet>
			{/* 	{user && ( */}
			<SheetTrigger className="lg:hidden" asChild>
				<Button className="h-8" variant="outline" size="icon">
					<MenuIcon size={20} />
				</Button>
			</SheetTrigger>
			{/* )} */}
			<SheetContent className="flex h-full flex-col px-3 sm:w-72" side="right">
				<SheetHeader>
					<Button className="flex items-center justify-center pb-2 pt-1" variant="link" asChild>
						<a href="/" className="flex items-center gap-2">
							<PanelsTopLeft className="mr-1 h-6 w-6" />
							<SheetTitle className="text-lg font-bold">BBC</SheetTitle>
						</a>
					</Button>
				</SheetHeader>
				{/* 	{user && ( */}

				<PublicMenu isOpen />
			</SheetContent>
		</Sheet>
	);
}
